module.exports = __webpack_public_path__ + "static/media/fading.4d9dcda5.jpg";